// extracted by css-extract-rspack-plugin
export default {"transparencyDataTable":"transparency-module__transparencyDataTable__Uaks8"};